

import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

//import { directive } from '@angular/core/src/render3/instructions';
import { Subscription } from 'rxjs/Subscription';
import { TelerikReportService } from './telerik-report.service';
import { telerikreport, ReportReSource } from './telerik-report.model';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { TelerikReportViewerComponent } from '@progress/telerik-angular-report-viewer';


@Component({
  selector: 'app-telrik-report',
  templateUrl: './telerik-report.view.html',

  styleUrls: ['./modal-basic.component.css']
})

export class TelerikReportComponent implements OnInit {

  public visible = false;
  public visibleAnimate = false;



  public reportname: string;
  public parameter: string;
  resource = <ReportReSource>{};
  tReportResource: JSON;
  closeResult: string;

  @ViewChild('content')
  private content: TemplateRef<any>;

  private subscription: Subscription;
  viewerContainerStyle = {
    position: 'relative',
    width: '800px',
    height: '600px',
    ['font-family']: 'ms sans serif'
  };
  reportsource: any;

  @ViewChild('viewer2', { static: true }) viewer: TelerikReportViewerComponent;
  
  reportSource: any;

  constructor(public messageservice: TelerikReportService, private modalService: NgbModal) {
   
  }
 


  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.visible = false;
    }
  }

  open(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit() {
   
    this.subscription = this.messageservice.loaderState
      .subscribe((state: telerikreport) => {
        if (state.show == true) {
          this.reportsource = {
            report: state.reportname,
            parameters: JSON.parse(state.parameter)
          }
          this.modalService.open(this.content, {size:'lg'}).result.then((result) => {
           
            this.closeResult = `Closed with: ${result}`;
          }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });;
          
          //var rs = {
          //  report: 'RREL.Report.ViewSO, RREL.Report',
          //  parameters: { SOId: 'SOMH23004426', branchcode: 3 }
          //};
          //this.viewer.setReportSource(rs);
         // this.viewer.setReportSource(rs);
         // this.reportviewer.refreshReport();
         // this.resource.report = state.reportname;
         // this.resource.parameters = JSON.parse(state.parameter);
         ////this.tReportResource = JSON.parse(JSON.stringify(this.resource));
         // this.reportviewer.setReportSource(JSON.parse(JSON.stringify(this.resource)));

         
        }

      });
  }

  public onButtonClick() {

    //this.reportsource = {
    //  report: 'FnoPortal.Report.SOPrint,FnoPortal.Report',
    //  parameters: { SalesId: 'SO000034' }
    //}
   //// reportSource=""
    var rs = {
      report: 'RREL.Report.ViewSO, RREL.Report',
      parameters: { SOId: 'SOMH23004427', branchcode: 3 }
    };
   this.viewer.setReportSource(rs);
   //// this.reportSource="{report: 'RREL.Report.ViewSO, RREL.Report', parameters: { SOId: 'SOMH23004426', branchcode: 3 }";
    
  }



  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
  }
  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }
}
